// This helper function will manipulate the return object for dynamic values, such as the color variation.
const manipulateStructuredData = function (baseData, md, posterColor, posterPresentation, currency, language) {
  // let md = getters.postersMetaData['babyroo']
  let color = null
  md.colors.forEach(function (c) {
    if (c.name === posterColor.name) {
      color = c
    }
  })

  // Fall back to the first color if we haven't selected a color for this particular poster.
  if (color === null) {
    color = md.colors[0]
  }

  let presentationID = ''
  switch (posterPresentation) {
    case 'fullsize':
      presentationID = '01'
      break
    case 'whiteFrame':
      presentationID = '02'
      break
  }

  baseData.sku = md.baseID + '-' + color.ID + '-' + presentationID
  baseData.offers.priceCurrency = currency.currency
  baseData.offers.price = md.prices[currency.currency] / 100
  baseData.image = process.env.BASE_URL + '/dist/static/product-images/' + baseData.sku + '.png'

  if (baseData.hasOwnProperty('description') && baseData.hasOwnProperty('brand') && baseData.hasOwnProperty('name')) {
    if (descriptions[language.iso]) {
      baseData.description = descriptions[language.iso]
        .replace(new RegExp('{{artist}}', 'g'), baseData.brand)
        .replace(new RegExp('{{name}}', 'g'), baseData.name)
    }
  }

  return baseData
}

const descriptions = {
  'sv': 'Köp {{name}} av {{artist}} på nätet. Du hittar även andra födelsetavlor av {{artist}} hos Born This Day.',
  'en': 'Buy the birth poster {{name}} by {{artist}} online. You will also find other birth posters from {{artist}} on Born This Day.'
}

export default {
  state: {
    // index is the structured data for the index page.
    index: {
      '@context': 'http://schema.org',
      '@type': 'Organization',
      name: 'Born This Day',
      legalName: 'Stroller AB',
      url: 'https://bornthisday.com',
      logo: 'data:image/svg+xml;base64,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',
      foundingDate: '2017',
      founders: [
        {
          '@type': 'Person',
          name: 'Patric Palmefjord'
        },
        {
          '@type': 'Person',
          name: 'Amanda Avsan'
        },
        {
          '@type': 'Person',
          name: 'Andreas Ovefelt'
        }
      ],
      address: {
        '@type': 'PostalAddress',
        streetAddress: 'Östermalmsgatan 26A',
        addressLocality: 'Stockholm',
        postalCode: 'SE-114 26',
        addressCountry: 'SWEDEN'
      },
      contactPoint: {
        '@type': 'ContactPoint',
        contactType: 'customer support',
        url: 'https://bornthisday.com/about/contact',
        email: 'hello@bornthisday.com'
      },
      sameAs: [
        'https://www.facebook.com/bornthisday.shop/',
        'https://www.instagram.com/bornthisday.shop/'
      ]
    },

    /*
     * @todo Colors and versions (full width / white border)!
     */

    // Ingela P Arrrhenius

    productPeekabooFullWidth: {
      '@context': 'http://www.schema.org',
      '@type': 'product',
      brand: 'Ingela P Arrhenius',
      logo: 'https://bornthisday.com/dist/static/logo_bordered.svg',
      sku: 'IPA-0001-01-01',
      name: 'Peekaboo',
      category: 'Birth posters',
      description: 'The illustrations are created by Ingela P. Arrhenius and each poster brings a splash of colour and life that will brighten up any space. You can easily create your own unique poster by filling in your child’s name, height, weight and date of birth.',
      aggregateRating: {
        '@type': 'aggregateRating',
        ratingValue: '5',
        reviewCount: '17'
      },
      offers: {
        '@type': 'Offer',
        availability: 'http://schema.org/InStock',
        price: '600',
        priceCurrency: 'SEK',
        image: 'https://bornthisday.s3.eu-central-1.amazonaws.com/posters/IPA-0001-01-01.png'
      }
    },

    productBabyrooFullWidth: {
      '@context': 'http://www.schema.org',
      '@type': 'product',
      brand: 'Ingela P Arrhenius',
      logo: 'https://bornthisday.com/dist/static/logo_bordered.svg',
      sku: 'IPA-0002-01-01',
      name: 'Baby roo',
      category: 'Birth posters',
      description: 'The illustrations are created by Ingela P. Arrhenius and each poster brings a splash of colour and life that will brighten up any space. You can easily create your own unique poster by filling in your child’s name, height, weight and date of birth.',
      aggregateRating: {
        '@type': 'aggregateRating',
        ratingValue: '5',
        reviewCount: '21'
      },
      offers: {
        '@type': 'Offer',
        availability: 'http://schema.org/InStock',
        price: '600',
        priceCurrency: 'SEK',
        image: 'https://bornthisday.s3.eu-central-1.amazonaws.com/posters/IPA-0002-01-01.png'
      }
    },

    productFoxyStrollinFullWidth: {
      '@context': 'http://www.schema.org',
      '@type': 'product',
      brand: 'Ingela P Arrhenius',
      logo: 'https://bornthisday.com/dist/static/logo_bordered.svg',
      sku: 'IPA-0003-01-01',
      name: 'Foxy Strollin\'',
      category: 'Birth posters',
      description: 'The illustrations are created by Ingela P. Arrhenius and each poster brings a splash of colour and life that will brighten up any space. You can easily create your own unique poster by filling in your child’s name, height, weight and date of birth.',
      aggregateRating: {
        '@type': 'aggregateRating',
        ratingValue: '5',
        reviewCount: '15'
      },
      offers: {
        '@type': 'Offer',
        availability: 'http://schema.org/InStock',
        price: '600',
        priceCurrency: 'SEK',
        image: 'https://bornthisday.s3.eu-central-1.amazonaws.com/posters/IPA-0003-01-01.png'
      }
    },

    productMockingbirdFullWidth: {
      '@context': 'http://www.schema.org',
      '@type': 'product',
      brand: 'Ingela P Arrhenius',
      logo: 'https://bornthisday.com/dist/static/logo_bordered.svg',
      sku: 'IPA-0004-01-01',
      name: 'Mockingbird',
      category: 'Birth posters',
      description: 'The illustrations are created by Ingela P. Arrhenius and each poster brings a splash of colour and life that will brighten up any space. You can easily create your own unique poster by filling in your child’s name, height, weight and date of birth.',
      aggregateRating: {
        '@type': 'aggregateRating',
        ratingValue: '5',
        reviewCount: '18'
      },
      offers: {
        '@type': 'Offer',
        availability: 'http://schema.org/InStock',
        price: '600',
        priceCurrency: 'SEK',
        image: 'https://bornthisday.s3.eu-central-1.amazonaws.com/posters/IPA-0004-01-01.png'
      }
    },

    productOwlinForYouFullWidth: {
      '@context': 'http://www.schema.org',
      '@type': 'product',
      brand: 'Ingela P Arrhenius',
      logo: 'https://bornthisday.com/dist/static/logo_bordered.svg',
      sku: 'IPA-0005-01-01',
      name: 'Owlin\' for Your',
      category: 'Birth posters',
      description: 'The illustrations are created by Ingela P. Arrhenius and each poster brings a splash of colour and life that will brighten up any space. You can easily create your own unique poster by filling in your child’s name, height, weight and date of birth.',
      aggregateRating: {
        '@type': 'aggregateRating',
        ratingValue: '5',
        reviewCount: '18'
      },
      offers: {
        '@type': 'Offer',
        availability: 'http://schema.org/InStock',
        price: '600',
        priceCurrency: 'SEK',
        image: 'https://bornthisday.s3.eu-central-1.amazonaws.com/posters/IPA-0005-01-01.png'
      }
    },

    productRetroBabyFullWidth: {
      '@context': 'http://www.schema.org',
      '@type': 'product',
      brand: 'Ingela P Arrhenius',
      logo: 'https://bornthisday.com/dist/static/logo_bordered.svg',
      sku: 'IPA-0006-02-01',
      name: 'Retro Baby',
      category: 'Birth posters',
      description: 'The illustrations are created by Ingela P. Arrhenius and each poster brings a splash of colour and life that will brighten up any space. You can easily create your own unique poster by filling in your child’s name, height, weight and date of birth.',
      aggregateRating: {
        '@type': 'aggregateRating',
        ratingValue: '5',
        reviewCount: '18'
      },
      offers: {
        '@type': 'Offer',
        availability: 'http://schema.org/InStock',
        price: '600',
        priceCurrency: 'SEK',
        image: 'https://bornthisday.s3.eu-central-1.amazonaws.com/posters/IPA-0006-01-01.png'
      }
    },

    productScandinavianForestFullWidth: {
      '@context': 'http://www.schema.org',
      '@type': 'product',
      brand: 'Ingela P Arrhenius',
      logo: 'https://bornthisday.com/dist/static/logo_bordered.svg',
      sku: 'IPA-0007-01-01',
      name: 'Scandinavian Forest',
      category: 'Birth posters',
      description: 'The illustrations are created by Ingela P. Arrhenius and each poster brings a splash of colour and life that will brighten up any space. You can easily create your own unique poster by filling in your child’s name, height, weight and date of birth.',
      aggregateRating: {
        '@type': 'aggregateRating',
        ratingValue: '5',
        reviewCount: '17'
      },
      offers: {
        '@type': 'Offer',
        availability: 'http://schema.org/InStock',
        price: '600',
        priceCurrency: 'SEK',
        image: 'https://bornthisday.s3.eu-central-1.amazonaws.com/posters/IPA-0007-01-01.png'
      }
    },

    productBornStrongFullWidth: {
      '@context': 'http://www.schema.org',
      '@type': 'product',
      brand: 'Ingela P Arrhenius',
      logo: 'https://bornthisday.com/dist/static/logo_bordered.svg',
      sku: 'IPA-0008-01-01',
      name: 'Born Strong',
      category: 'Birth posters',
      description: 'The illustrations are created by Ingela P. Arrhenius and each poster brings a splash of colour and life that will brighten up any space. You can easily create your own unique poster by filling in your child’s name, height, weight and date of birth.',
      aggregateRating: {
        '@type': 'aggregateRating',
        ratingValue: '5',
        reviewCount: '13'
      },
      offers: {
        '@type': 'Offer',
        availability: 'http://schema.org/InStock',
        price: '600',
        priceCurrency: 'SEK',
        image: 'https://bornthisday.s3.eu-central-1.amazonaws.com/posters/IPA-0008-01-01.png'
      }
    },

    productWhatTheFoxSayFullWidth: {
      '@context': 'http://www.schema.org',
      '@type': 'product',
      brand: 'Ingela P Arrhenius',
      logo: 'https://bornthisday.com/dist/static/logo_bordered.svg',
      sku: 'IPA-0009-01-01',
      name: 'What The Fox Say',
      category: 'Birth posters',
      description: 'The illustrations are created by Ingela P. Arrhenius and each poster brings a splash of colour and life that will brighten up any space. You can easily create your own unique poster by filling in your child’s name, height, weight and date of birth.',
      aggregateRating: {
        '@type': 'aggregateRating',
        ratingValue: '5',
        reviewCount: '15'
      },
      offers: {
        '@type': 'Offer',
        availability: 'http://schema.org/InStock',
        price: '600',
        priceCurrency: 'SEK',
        image: 'https://bornthisday.s3.eu-central-1.amazonaws.com/posters/IPA-0009-01-01.png'
      }
    },

    productShortyAndStretchFullWidth: {
      '@context': 'http://www.schema.org',
      '@type': 'product',
      brand: 'Ingela P Arrhenius',
      logo: 'https://bornthisday.com/dist/static/logo_bordered.svg',
      sku: 'IPA-0010-01-01',
      name: 'Shorty And Stretch',
      category: 'Birth posters',
      description: 'The illustrations are created by Ingela P. Arrhenius and each poster brings a splash of colour and life that will brighten up any space. You can easily create your own unique poster by filling in your child’s name, height, weight and date of birth.',
      aggregateRating: {
        '@type': 'aggregateRating',
        ratingValue: '5',
        reviewCount: '15'
      },
      offers: {
        '@type': 'Offer',
        availability: 'http://schema.org/InStock',
        price: '600',
        priceCurrency: 'SEK',
        image: 'https://bornthisday.s3.eu-central-1.amazonaws.com/posters/IPA-0010-01-01.png'
      }
    },

    productAdorableFullWidth: {
      '@context': 'http://www.schema.org',
      '@type': 'product',
      brand: 'Peytil',
      logo: 'https://bornthisday.com/dist/static/logo_bordered.svg',
      sku: 'PEY-0001-01-01',
      name: 'Adorable',
      category: 'Birth posters',
      description: 'The illustrations are created by Eitil Thorén Due also known as Peytil. The poster adapts in the scale 1:1 to your baby’s actual length and weight and makes a lovely, personalized memory of the birth of your child.',
      aggregateRating: {
        '@type': 'aggregateRating',
        ratingValue: '5',
        reviewCount: '15'
      },
      offers: {
        '@type': 'Offer',
        availability: 'http://schema.org/InStock',
        price: '600',
        priceCurrency: 'SEK',
        image: 'https://bornthisday.s3.eu-central-1.amazonaws.com/posters/PEY-0001-01-01.png'
      }
    },

    productPlayfulFullWidth: {
      '@context': 'http://www.schema.org',
      '@type': 'product',
      brand: 'Peytil',
      logo: 'https://bornthisday.com/dist/static/logo_bordered.svg',
      sku: 'PEY-0002-01-01',
      name: 'Playful',
      category: 'Birth posters',
      description: 'The illustrations are created by Eitil Thorén Due also known as Peytil. The poster adapts in the scale 1:1 to your baby’s actual length and weight and makes a lovely, personalized memory of the birth of your child.',
      aggregateRating: {
        '@type': 'aggregateRating',
        ratingValue: '5',
        reviewCount: '15'
      },
      offers: {
        '@type': 'Offer',
        availability: 'http://schema.org/InStock',
        price: '600',
        priceCurrency: 'SEK',
        image: 'https://bornthisday.s3.eu-central-1.amazonaws.com/posters/PEY-0002-01-01.png'
      }
    },

    productDelightfulFullWidth: {
      '@context': 'http://www.schema.org',
      '@type': 'product',
      brand: 'Peytil',
      logo: 'https://bornthisday.com/dist/static/logo_bordered.svg',
      sku: 'PEY-0003-01-01',
      name: 'Delightful',
      category: 'Birth posters',
      description: 'The illustrations are created by Eitil Thorén Due also known as Peytil. The poster adapts in the scale 1:1 to your baby’s actual length and weight and makes a lovely, personalized memory of the birth of your child.',
      aggregateRating: {
        '@type': 'aggregateRating',
        ratingValue: '5',
        reviewCount: '17'
      },
      offers: {
        '@type': 'Offer',
        availability: 'http://schema.org/InStock',
        price: '600',
        priceCurrency: 'SEK',
        image: 'https://bornthisday.s3.eu-central-1.amazonaws.com/posters/PEY-0003-01-01.png'
      }
    },

    productRosetteFullWidth: {
      '@context': 'http://www.schema.org',
      '@type': 'product',
      brand: 'Peytil',
      logo: 'https://bornthisday.com/dist/static/logo_bordered.svg',
      sku: 'PEY-0004-01-01',
      name: 'Rosette',
      category: 'Birth posters',
      description: 'The illustrations are created by Eitil Thorén Due also known as Peytil. The poster adapts in the scale 1:1 to your baby’s actual length and weight and makes a lovely, personalized memory of the birth of your child.',
      aggregateRating: {
        '@type': 'aggregateRating',
        ratingValue: '5',
        reviewCount: '22'
      },
      offers: {
        '@type': 'Offer',
        availability: 'http://schema.org/InStock',
        price: '600',
        priceCurrency: 'SEK',
        image: 'https://bornthisday.s3.eu-central-1.amazonaws.com/posters/PEY-0004-01-01.png'
      }
    },

    productBlossomAFullWidth: {
      '@context': 'http://www.schema.org',
      '@type': 'product',
      brand: 'Katarzyna Stróżyńska Goraj',
      logo: 'https://bornthisday.com/dist/static/logo_bordered.svg',
      sku: 'KSG-0001-01-01',
      name: 'Blossom: A',
      category: 'Birth posters',
      description: 'The illustrations are created by Katarzyna Stróżyńska Goraj also known as Draupadia. The poster is adapted according to your settings and makes a lovely, personalized memory of the birth of your child.',
      aggregateRating: {
        '@type': 'aggregateRating',
        ratingValue: '5',
        reviewCount: '10'
      },
      offers: {
        '@type': 'Offer',
        availability: 'http://schema.org/InStock',
        price: '600',
        priceCurrency: 'SEK',
        image: 'https://bornthisday.s3.eu-central-1.amazonaws.com/posters/KSG-0001-01-01.png'
      }
    },

    productBlossomBFullWidth: {
      '@context': 'http://www.schema.org',
      '@type': 'product',
      brand: 'Katarzyna Stróżyńska Goraj',
      logo: 'https://bornthisday.com/dist/static/logo_bordered.svg',
      sku: 'KSG-0002-01-01',
      name: 'Blossom: B',
      category: 'Birth posters',
      description: 'The illustrations are created by Katarzyna Stróżyńska Goraj also known as Draupadia. The poster is adapted according to your settings and makes a lovely, personalized memory of the birth of your child.',
      aggregateRating: {
        '@type': 'aggregateRating',
        ratingValue: '5',
        reviewCount: '19'
      },
      offers: {
        '@type': 'Offer',
        availability: 'http://schema.org/InStock',
        price: '600',
        priceCurrency: 'SEK',
        image: 'https://bornthisday.s3.eu-central-1.amazonaws.com/posters/KSG-0002-01-01.png'
      }
    },

    productBlossomCFullWidth: {
      '@context': 'http://www.schema.org',
      '@type': 'product',
      brand: 'Katarzyna Stróżyńska Goraj',
      logo: 'https://bornthisday.com/dist/static/logo_bordered.svg',
      sku: 'KSG-0003-01-01',
      name: 'Blossom: C',
      category: 'Birth posters',
      description: 'The illustrations are created by Katarzyna Stróżyńska Goraj also known as Draupadia. The poster is adapted according to your settings and makes a lovely, personalized memory of the birth of your child.',
      aggregateRating: {
        '@type': 'aggregateRating',
        ratingValue: '5',
        reviewCount: '25'
      },
      offers: {
        '@type': 'Offer',
        availability: 'http://schema.org/InStock',
        price: '600',
        priceCurrency: 'SEK',
        image: 'https://bornthisday.s3.eu-central-1.amazonaws.com/posters/KSG-0003-01-01.png'
      }
    },

    productBlossomDFullWidth: {
      '@context': 'http://www.schema.org',
      '@type': 'product',
      brand: 'Katarzyna Stróżyńska Goraj',
      logo: 'https://bornthisday.com/dist/static/logo_bordered.svg',
      sku: 'KSG-0004-01-01',
      name: 'Blossom: D',
      category: 'Birth posters',
      description: 'The illustrations are created by Katarzyna Stróżyńska Goraj also known as Draupadia. The poster is adapted according to your settings and makes a lovely, personalized memory of the birth of your child.',
      aggregateRating: {
        '@type': 'aggregateRating',
        ratingValue: '5',
        reviewCount: '8'
      },
      offers: {
        '@type': 'Offer',
        availability: 'http://schema.org/InStock',
        price: '600',
        priceCurrency: 'SEK',
        image: 'https://bornthisday.s3.eu-central-1.amazonaws.com/posters/KSG-0004-01-01.png'
      }
    },

    productBlossomEFullWidth: {
      '@context': 'http://www.schema.org',
      '@type': 'product',
      brand: 'Katarzyna Stróżyńska Goraj',
      logo: 'https://bornthisday.com/dist/static/logo_bordered.svg',
      sku: 'KSG-0005-01-01',
      name: 'Blossom: E',
      category: 'Birth posters',
      description: 'The illustrations are created by Katarzyna Stróżyńska Goraj also known as Draupadia. The poster is adapted according to your settings and makes a lovely, personalized memory of the birth of your child.',
      aggregateRating: {
        '@type': 'aggregateRating',
        ratingValue: '5',
        reviewCount: '21'
      },
      offers: {
        '@type': 'Offer',
        availability: 'http://schema.org/InStock',
        price: '600',
        priceCurrency: 'SEK',
        image: 'https://bornthisday.s3.eu-central-1.amazonaws.com/posters/KSG-0005-01-01.png'
      }
    },

    productBlossomFFullWidth: {
      '@context': 'http://www.schema.org',
      '@type': 'product',
      brand: 'Katarzyna Stróżyńska Goraj',
      logo: 'https://bornthisday.com/dist/static/logo_bordered.svg',
      sku: 'KSG-0006-01-01',
      name: 'Blossom: F',
      category: 'Birth posters',
      description: 'The illustrations are created by Katarzyna Stróżyńska Goraj also known as Draupadia. The poster is adapted according to your settings and makes a lovely, personalized memory of the birth of your child.',
      aggregateRating: {
        '@type': 'aggregateRating',
        ratingValue: '5',
        reviewCount: '9'
      },
      offers: {
        '@type': 'Offer',
        availability: 'http://schema.org/InStock',
        price: '600',
        priceCurrency: 'SEK',
        image: 'https://bornthisday.s3.eu-central-1.amazonaws.com/posters/KSG-0006-01-01.png'
      }
    },

    productBlossomGFullWidth: {
      '@context': 'http://www.schema.org',
      '@type': 'product',
      brand: 'Katarzyna Stróżyńska Goraj',
      logo: 'https://bornthisday.com/dist/static/logo_bordered.svg',
      sku: 'KSG-0007-01-01',
      name: 'Blossom: G',
      category: 'Birth posters',
      description: 'The illustrations are created by Katarzyna Stróżyńska Goraj also known as Draupadia. The poster is adapted according to your settings and makes a lovely, personalized memory of the birth of your child.',
      aggregateRating: {
        '@type': 'aggregateRating',
        ratingValue: '5',
        reviewCount: '22'
      },
      offers: {
        '@type': 'Offer',
        availability: 'http://schema.org/InStock',
        price: '600',
        priceCurrency: 'SEK',
        image: 'https://bornthisday.s3.eu-central-1.amazonaws.com/posters/KSG-0007-01-01.png'
      }
    },

    productBlossomHFullWidth: {
      '@context': 'http://www.schema.org',
      '@type': 'product',
      brand: 'Katarzyna Stróżyńska Goraj',
      logo: 'https://bornthisday.com/dist/static/logo_bordered.svg',
      sku: 'KSG-0008-01-01',
      name: 'Blossom: H',
      category: 'Birth posters',
      description: 'The illustrations are created by Katarzyna Stróżyńska Goraj also known as Draupadia. The poster is adapted according to your settings and makes a lovely, personalized memory of the birth of your child.',
      aggregateRating: {
        '@type': 'aggregateRating',
        ratingValue: '5',
        reviewCount: '10'
      },
      offers: {
        '@type': 'Offer',
        availability: 'http://schema.org/InStock',
        price: '600',
        priceCurrency: 'SEK',
        image: 'https://bornthisday.s3.eu-central-1.amazonaws.com/posters/KSG-0008-01-01.png'
      }
    },

    productBlossomIFullWidth: {
      '@context': 'http://www.schema.org',
      '@type': 'product',
      brand: 'Katarzyna Stróżyńska Goraj',
      logo: 'https://bornthisday.com/dist/static/logo_bordered.svg',
      sku: 'KSG-0009-01-01',
      name: 'Blossom: I',
      category: 'Birth posters',
      description: 'The illustrations are created by Katarzyna Stróżyńska Goraj also known as Draupadia. The poster is adapted according to your settings and makes a lovely, personalized memory of the birth of your child.',
      aggregateRating: {
        '@type': 'aggregateRating',
        ratingValue: '5',
        reviewCount: '17'
      },
      offers: {
        '@type': 'Offer',
        availability: 'http://schema.org/InStock',
        price: '600',
        priceCurrency: 'SEK',
        image: 'https://bornthisday.s3.eu-central-1.amazonaws.com/posters/KSG-0009-01-01.png'
      }
    },

    productBlossomJFullWidth: {
      '@context': 'http://www.schema.org',
      '@type': 'product',
      brand: 'Katarzyna Stróżyńska Goraj',
      logo: 'https://bornthisday.com/dist/static/logo_bordered.svg',
      sku: 'KSG-0010-01-01',
      name: 'Blossom: J',
      category: 'Birth posters',
      description: 'The illustrations are created by Katarzyna Stróżyńska Goraj also known as Draupadia. The poster is adapted according to your settings and makes a lovely, personalized memory of the birth of your child.',
      aggregateRating: {
        '@type': 'aggregateRating',
        ratingValue: '5',
        reviewCount: '12'
      },
      offers: {
        '@type': 'Offer',
        availability: 'http://schema.org/InStock',
        price: '600',
        priceCurrency: 'SEK',
        image: 'https://bornthisday.s3.eu-central-1.amazonaws.com/posters/KSG-0010-01-01.png'
      }
    },

    productBlossomKFullWidth: {
      '@context': 'http://www.schema.org',
      '@type': 'product',
      brand: 'Katarzyna Stróżyńska Goraj',
      logo: 'https://bornthisday.com/dist/static/logo_bordered.svg',
      sku: 'KSG-0011-01-01',
      name: 'Blossom: K',
      category: 'Birth posters',
      description: 'The illustrations are created by Katarzyna Stróżyńska Goraj also known as Draupadia. The poster is adapted according to your settings and makes a lovely, personalized memory of the birth of your child.',
      aggregateRating: {
        '@type': 'aggregateRating',
        ratingValue: '5',
        reviewCount: '19'
      },
      offers: {
        '@type': 'Offer',
        availability: 'http://schema.org/InStock',
        price: '600',
        priceCurrency: 'SEK',
        image: 'https://bornthisday.s3.eu-central-1.amazonaws.com/posters/KSG-0011-01-01.png'
      }
    },

    productBlossomLFullWidth: {
      '@context': 'http://www.schema.org',
      '@type': 'product',
      brand: 'Katarzyna Stróżyńska Goraj',
      logo: 'https://bornthisday.com/dist/static/logo_bordered.svg',
      sku: 'KSG-0012-01-01',
      name: 'Blossom: L',
      category: 'Birth posters',
      description: 'The illustrations are created by Katarzyna Stróżyńska Goraj also known as Draupadia. The poster is adapted according to your settings and makes a lovely, personalized memory of the birth of your child.',
      aggregateRating: {
        '@type': 'aggregateRating',
        ratingValue: '5',
        reviewCount: '31'
      },
      offers: {
        '@type': 'Offer',
        availability: 'http://schema.org/InStock',
        price: '600',
        priceCurrency: 'SEK',
        image: 'https://bornthisday.s3.eu-central-1.amazonaws.com/posters/KSG-0012-01-01.png'
      }
    },

    productBlossomMFullWidth: {
      '@context': 'http://www.schema.org',
      '@type': 'product',
      brand: 'Katarzyna Stróżyńska Goraj',
      logo: 'https://bornthisday.com/dist/static/logo_bordered.svg',
      sku: 'KSG-0013-01-01',
      name: 'Blossom: M',
      category: 'Birth posters',
      description: 'The illustrations are created by Katarzyna Stróżyńska Goraj also known as Draupadia. The poster is adapted according to your settings and makes a lovely, personalized memory of the birth of your child.',
      aggregateRating: {
        '@type': 'aggregateRating',
        ratingValue: '5',
        reviewCount: '19'
      },
      offers: {
        '@type': 'Offer',
        availability: 'http://schema.org/InStock',
        price: '600',
        priceCurrency: 'SEK',
        image: 'https://bornthisday.s3.eu-central-1.amazonaws.com/posters/KSG-0013-01-01.png'
      }
    },

    productBlossomNFullWidth: {
      '@context': 'http://www.schema.org',
      '@type': 'product',
      brand: 'Katarzyna Stróżyńska Goraj',
      logo: 'https://bornthisday.com/dist/static/logo_bordered.svg',
      sku: 'KSG-0014-01-01',
      name: 'Blossom: N',
      category: 'Birth posters',
      description: 'The illustrations are created by Katarzyna Stróżyńska Goraj also known as Draupadia. The poster is adapted according to your settings and makes a lovely, personalized memory of the birth of your child.',
      aggregateRating: {
        '@type': 'aggregateRating',
        ratingValue: '5',
        reviewCount: '15'
      },
      offers: {
        '@type': 'Offer',
        availability: 'http://schema.org/InStock',
        price: '600',
        priceCurrency: 'SEK',
        image: 'https://bornthisday.s3.eu-central-1.amazonaws.com/posters/KSG-0014-01-01.png'
      }
    },

    productBlossomOFullWidth: {
      '@context': 'http://www.schema.org',
      '@type': 'product',
      brand: 'Katarzyna Stróżyńska Goraj',
      logo: 'https://bornthisday.com/dist/static/logo_bordered.svg',
      sku: 'KSG-0015-01-01',
      name: 'Blossom: O',
      category: 'Birth posters',
      description: 'The illustrations are created by Katarzyna Stróżyńska Goraj also known as Draupadia. The poster is adapted according to your settings and makes a lovely, personalized memory of the birth of your child.',
      aggregateRating: {
        '@type': 'aggregateRating',
        ratingValue: '5',
        reviewCount: '10'
      },
      offers: {
        '@type': 'Offer',
        availability: 'http://schema.org/InStock',
        price: '600',
        priceCurrency: 'SEK',
        image: 'https://bornthisday.s3.eu-central-1.amazonaws.com/posters/KSG-0015-01-01.png'
      }
    },

    productBlossomPFullWidth: {
      '@context': 'http://www.schema.org',
      '@type': 'product',
      brand: 'Katarzyna Stróżyńska Goraj',
      logo: 'https://bornthisday.com/dist/static/logo_bordered.svg',
      sku: 'KSG-0016-01-01',
      name: 'Blossom: P',
      category: 'Birth posters',
      description: 'The illustrations are created by Katarzyna Stróżyńska Goraj also known as Draupadia. The poster is adapted according to your settings and makes a lovely, personalized memory of the birth of your child.',
      aggregateRating: {
        '@type': 'aggregateRating',
        ratingValue: '5',
        reviewCount: '14'
      },
      offers: {
        '@type': 'Offer',
        availability: 'http://schema.org/InStock',
        price: '600',
        priceCurrency: 'SEK',
        image: 'https://bornthisday.s3.eu-central-1.amazonaws.com/posters/KSG-0016-01-01.png'
      }
    },

    productBlossomQFullWidth: {
      '@context': 'http://www.schema.org',
      '@type': 'product',
      brand: 'Katarzyna Stróżyńska Goraj',
      logo: 'https://bornthisday.com/dist/static/logo_bordered.svg',
      sku: 'KSG-0017-01-01',
      name: 'Blossom: Q',
      category: 'Birth posters',
      description: 'The illustrations are created by Katarzyna Stróżyńska Goraj also known as Draupadia. The poster is adapted according to your settings and makes a lovely, personalized memory of the birth of your child.',
      aggregateRating: {
        '@type': 'aggregateRating',
        ratingValue: '5',
        reviewCount: '3'
      },
      offers: {
        '@type': 'Offer',
        availability: 'http://schema.org/InStock',
        price: '600',
        priceCurrency: 'SEK',
        image: 'https://bornthisday.s3.eu-central-1.amazonaws.com/posters/KSG-0017-01-01.png'
      }
    },

    productBlossomRFullWidth: {
      '@context': 'http://www.schema.org',
      '@type': 'product',
      brand: 'Katarzyna Stróżyńska Goraj',
      logo: 'https://bornthisday.com/dist/static/logo_bordered.svg',
      sku: 'KSG-0018-01-01',
      name: 'Blossom: R',
      category: 'Birth posters',
      description: 'The illustrations are created by Katarzyna Stróżyńska Goraj also known as Draupadia. The poster is adapted according to your settings and makes a lovely, personalized memory of the birth of your child.',
      aggregateRating: {
        '@type': 'aggregateRating',
        ratingValue: '5',
        reviewCount: '18'
      },
      offers: {
        '@type': 'Offer',
        availability: 'http://schema.org/InStock',
        price: '600',
        priceCurrency: 'SEK',
        image: 'https://bornthisday.s3.eu-central-1.amazonaws.com/posters/KSG-0018-01-01.png'
      }
    },

    productBlossomSFullWidth: {
      '@context': 'http://www.schema.org',
      '@type': 'product',
      brand: 'Katarzyna Stróżyńska Goraj',
      logo: 'https://bornthisday.com/dist/static/logo_bordered.svg',
      sku: 'KSG-0019-01-01',
      name: 'Blossom: S',
      category: 'Birth posters',
      description: 'The illustrations are created by Katarzyna Stróżyńska Goraj also known as Draupadia. The poster is adapted according to your settings and makes a lovely, personalized memory of the birth of your child.',
      aggregateRating: {
        '@type': 'aggregateRating',
        ratingValue: '5',
        reviewCount: '33'
      },
      offers: {
        '@type': 'Offer',
        availability: 'http://schema.org/InStock',
        price: '600',
        priceCurrency: 'SEK',
        image: 'https://bornthisday.s3.eu-central-1.amazonaws.com/posters/KSG-0019-01-01.png'
      }
    },

    productBlossomTFullWidth: {
      '@context': 'http://www.schema.org',
      '@type': 'product',
      brand: 'Katarzyna Stróżyńska Goraj',
      logo: 'https://bornthisday.com/dist/static/logo_bordered.svg',
      sku: 'KSG-0020-01-01',
      name: 'Blossom: T',
      category: 'Birth posters',
      description: 'The illustrations are created by Katarzyna Stróżyńska Goraj also known as Draupadia. The poster is adapted according to your settings and makes a lovely, personalized memory of the birth of your child.',
      aggregateRating: {
        '@type': 'aggregateRating',
        ratingValue: '5',
        reviewCount: '15'
      },
      offers: {
        '@type': 'Offer',
        availability: 'http://schema.org/InStock',
        price: '600',
        priceCurrency: 'SEK',
        image: 'https://bornthisday.s3.eu-central-1.amazonaws.com/posters/KSG-0020-01-01.png'
      }
    },

    productBlossomUFullWidth: {
      '@context': 'http://www.schema.org',
      '@type': 'product',
      brand: 'Katarzyna Stróżyńska Goraj',
      logo: 'https://bornthisday.com/dist/static/logo_bordered.svg',
      sku: 'KSG-0021-01-01',
      name: 'Blossom: U',
      category: 'Birth posters',
      description: 'The illustrations are created by Katarzyna Stróżyńska Goraj also known as Draupadia. The poster is adapted according to your settings and makes a lovely, personalized memory of the birth of your child.',
      aggregateRating: {
        '@type': 'aggregateRating',
        ratingValue: '5',
        reviewCount: '5'
      },
      offers: {
        '@type': 'Offer',
        availability: 'http://schema.org/InStock',
        price: '600',
        priceCurrency: 'SEK',
        image: 'https://bornthisday.s3.eu-central-1.amazonaws.com/posters/KSG-0021-01-01.png'
      }
    },

    productBlossomVFullWidth: {
      '@context': 'http://www.schema.org',
      '@type': 'product',
      brand: 'Katarzyna Stróżyńska Goraj',
      logo: 'https://bornthisday.com/dist/static/logo_bordered.svg',
      sku: 'KSG-0022-01-01',
      name: 'Blossom: V',
      category: 'Birth posters',
      description: 'The illustrations are created by Katarzyna Stróżyńska Goraj also known as Draupadia. The poster is adapted according to your settings and makes a lovely, personalized memory of the birth of your child.',
      aggregateRating: {
        '@type': 'aggregateRating',
        ratingValue: '5',
        reviewCount: '16'
      },
      offers: {
        '@type': 'Offer',
        availability: 'http://schema.org/InStock',
        price: '600',
        priceCurrency: 'SEK',
        image: 'https://bornthisday.s3.eu-central-1.amazonaws.com/posters/KSG-0022-01-01.png'
      }
    },

    productBlossomWFullWidth: {
      '@context': 'http://www.schema.org',
      '@type': 'product',
      brand: 'Katarzyna Stróżyńska Goraj',
      logo: 'https://bornthisday.com/dist/static/logo_bordered.svg',
      sku: 'KSG-0023-01-01',
      name: 'Blossom: W',
      category: 'Birth posters',
      description: 'The illustrations are created by Katarzyna Stróżyńska Goraj also known as Draupadia. The poster is adapted according to your settings and makes a lovely, personalized memory of the birth of your child.',
      aggregateRating: {
        '@type': 'aggregateRating',
        ratingValue: '5',
        reviewCount: '3'
      },
      offers: {
        '@type': 'Offer',
        availability: 'http://schema.org/InStock',
        price: '600',
        priceCurrency: 'SEK',
        image: 'https://bornthisday.s3.eu-central-1.amazonaws.com/posters/KSG-0023-01-01.png'
      }
    },

    productBlossomXFullWidth: {
      '@context': 'http://www.schema.org',
      '@type': 'product',
      brand: 'Katarzyna Stróżyńska Goraj',
      logo: 'https://bornthisday.com/dist/static/logo_bordered.svg',
      sku: 'KSG-0024-01-01',
      name: 'Blossom: X',
      category: 'Birth posters',
      description: 'The illustrations are created by Katarzyna Stróżyńska Goraj also known as Draupadia. The poster is adapted according to your settings and makes a lovely, personalized memory of the birth of your child.',
      aggregateRating: {
        '@type': 'aggregateRating',
        ratingValue: '5',
        reviewCount: '2'
      },
      offers: {
        '@type': 'Offer',
        availability: 'http://schema.org/InStock',
        price: '600',
        priceCurrency: 'SEK',
        image: 'https://bornthisday.s3.eu-central-1.amazonaws.com/posters/KSG-0024-01-01.png'
      }
    },

    productBlossomYFullWidth: {
      '@context': 'http://www.schema.org',
      '@type': 'product',
      brand: 'Katarzyna Stróżyńska Goraj',
      logo: 'https://bornthisday.com/dist/static/logo_bordered.svg',
      sku: 'KSG-0025-01-01',
      name: 'Blossom: Y',
      category: 'Birth posters',
      description: 'The illustrations are created by Katarzyna Stróżyńska Goraj also known as Draupadia. The poster is adapted according to your settings and makes a lovely, personalized memory of the birth of your child.',
      aggregateRating: {
        '@type': 'aggregateRating',
        ratingValue: '5',
        reviewCount: '3'
      },
      offers: {
        '@type': 'Offer',
        availability: 'http://schema.org/InStock',
        price: '600',
        priceCurrency: 'SEK',
        image: 'https://bornthisday.s3.eu-central-1.amazonaws.com/posters/KSG-0025-01-01.png'
      }
    },

    productBlossomZFullWidth: {
      '@context': 'http://www.schema.org',
      '@type': 'product',
      brand: 'Katarzyna Stróżyńska Goraj',
      logo: 'https://bornthisday.com/dist/static/logo_bordered.svg',
      sku: 'KSG-0026-01-01',
      name: 'Blossom: Z',
      category: 'Birth posters',
      description: 'The illustrations are created by Katarzyna Stróżyńska Goraj also known as Draupadia. The poster is adapted according to your settings and makes a lovely, personalized memory of the birth of your child.',
      aggregateRating: {
        '@type': 'aggregateRating',
        ratingValue: '4',
        reviewCount: '2'
      },
      offers: {
        '@type': 'Offer',
        availability: 'http://schema.org/InStock',
        price: '600',
        priceCurrency: 'SEK',
        image: 'https://bornthisday.s3.eu-central-1.amazonaws.com/posters/KSG-0026-01-01.png'
      }
    },

    productBlossomAringFullWidth: {
      '@context': 'http://www.schema.org',
      '@type': 'product',
      brand: 'Katarzyna Stróżyńska Goraj',
      logo: 'https://bornthisday.com/dist/static/logo_bordered.svg',
      sku: 'KSG-0027-01-01',
      name: 'Blossom: Å',
      category: 'Birth posters',
      description: 'The illustrations are created by Katarzyna Stróżyńska Goraj also known as Draupadia. The poster is adapted according to your settings and makes a lovely, personalized memory of the birth of your child.',
      aggregateRating: {
        '@type': 'aggregateRating',
        ratingValue: '5',
        reviewCount: '10'
      },
      offers: {
        '@type': 'Offer',
        availability: 'http://schema.org/InStock',
        price: '600',
        priceCurrency: 'SEK',
        image: 'https://bornthisday.s3.eu-central-1.amazonaws.com/posters/KSG-0027-01-01.png'
      }
    },

    productBlossomAumlFullWidth: {
      '@context': 'http://www.schema.org',
      '@type': 'product',
      brand: 'Katarzyna Stróżyńska Goraj',
      logo: 'https://bornthisday.com/dist/static/logo_bordered.svg',
      sku: 'KSG-0028-01-01',
      name: 'Blossom: Ä',
      category: 'Birth posters',
      description: 'The illustrations are created by Katarzyna Stróżyńska Goraj also known as Draupadia. The poster is adapted according to your settings and makes a lovely, personalized memory of the birth of your child.',
      aggregateRating: {
        '@type': 'aggregateRating',
        ratingValue: '5',
        reviewCount: '7'
      },
      offers: {
        '@type': 'Offer',
        availability: 'http://schema.org/InStock',
        price: '600',
        priceCurrency: 'SEK',
        image: 'https://bornthisday.s3.eu-central-1.amazonaws.com/posters/KSG-0028-01-01.png'
      }
    },

    productBlossomOumlFullWidth: {
      '@context': 'http://www.schema.org',
      '@type': 'product',
      brand: 'Katarzyna Stróżyńska Goraj',
      logo: 'https://bornthisday.com/dist/static/logo_bordered.svg',
      sku: 'KSG-0029-01-01',
      name: 'Blossom: Ö',
      category: 'Birth posters',
      description: 'The illustrations are created by Katarzyna Stróżyńska Goraj also known as Draupadia. The poster is adapted according to your settings and makes a lovely, personalized memory of the birth of your child.',
      aggregateRating: {
        '@type': 'aggregateRating',
        ratingValue: '4',
        reviewCount: '10'
      },
      offers: {
        '@type': 'Offer',
        availability: 'http://schema.org/InStock',
        price: '600',
        priceCurrency: 'SEK',
        image: 'https://bornthisday.s3.eu-central-1.amazonaws.com/posters/KSG-0029-01-01.png'
      }
    },

    productBlossomAeligFullWidth: {
      '@context': 'http://www.schema.org',
      '@type': 'product',
      brand: 'Katarzyna Stróżyńska Goraj',
      logo: 'https://bornthisday.com/dist/static/logo_bordered.svg',
      sku: 'KSG-0030-01-01',
      name: 'Blossom: Æ',
      category: 'Birth posters',
      description: 'The illustrations are created by Katarzyna Stróżyńska Goraj also known as Draupadia. The poster is adapted according to your settings and makes a lovely, personalized memory of the birth of your child.',
      aggregateRating: {
        '@type': 'aggregateRating',
        ratingValue: '4',
        reviewCount: '2'
      },
      offers: {
        '@type': 'Offer',
        availability: 'http://schema.org/InStock',
        price: '600',
        priceCurrency: 'SEK',
        image: 'https://bornthisday.s3.eu-central-1.amazonaws.com/posters/KSG-0030-01-01.png'
      }
    },

    productBlossomOslashFullWidth: {
      '@context': 'http://www.schema.org',
      '@type': 'product',
      brand: 'Katarzyna Stróżyńska Goraj',
      logo: 'https://bornthisday.com/dist/static/logo_bordered.svg',
      sku: 'KSG-0031-01-01',
      name: 'Blossom: Ø',
      category: 'Birth posters',
      description: 'The illustrations are created by Katarzyna Stróżyńska Goraj also known as Draupadia. The poster is adapted according to your settings and makes a lovely, personalized memory of the birth of your child.',
      aggregateRating: {
        '@type': 'aggregateRating',
        ratingValue: '5',
        reviewCount: '4'
      },
      offers: {
        '@type': 'Offer',
        availability: 'http://schema.org/InStock',
        price: '600',
        priceCurrency: 'SEK',
        image: 'https://bornthisday.s3.eu-central-1.amazonaws.com/posters/KSG-0031-01-01.png'
      }
    },

    productBlossomYumlFullWidth: {
      '@context': 'http://www.schema.org',
      '@type': 'product',
      brand: 'Katarzyna Stróżyńska Goraj',
      logo: 'https://bornthisday.com/dist/static/logo_bordered.svg',
      sku: 'KSG-0032-01-01',
      name: 'Blossom: Ÿ',
      category: 'Birth posters',
      description: 'The illustrations are created by Katarzyna Stróżyńska Goraj also known as Draupadia. The poster is adapted according to your settings and makes a lovely, personalized memory of the birth of your child.',
      aggregateRating: {
        '@type': 'aggregateRating',
        ratingValue: '5',
        reviewCount: '2'
      },
      offers: {
        '@type': 'Offer',
        availability: 'http://schema.org/InStock',
        price: '600',
        priceCurrency: 'SEK',
        image: 'https://bornthisday.s3.eu-central-1.amazonaws.com/posters/KSG-0032-01-01.png'
      }
    }
  },

  mutations: {},

  actions: {},

  getters: {
    structuredDataIndex (state) {
      let data = state.index
      const hostname = window.location.hostname.toLowerCase()
      const [ topDomain ] = hostname.match(/(localhost|\.\w{2,4}$)/gm)
      if (topDomain.toLowerCase() !== 'localhost') {
        data.url = window.location.protocol.toLowerCase() + '//' + hostname
        if (topDomain.toLowerCase() === '.se') {
          data.contactPoint.url = data.url + '/om-oss/kontakt'
        } else {
          data.contactPoint.url = data.url + '/about/contact'
        }
      }
      return data
    },

    // @todo In the below getters, check the currently selected currency and update the "offers" property based on it before returning.

    // Ingela P. Arrhenius

    structuredDataProductPeekaboo (state, getters) {
      // Obtain the base return object.
      // JSON parse because: Error: [vuex] Do not mutate vuex store state outside mutation handlers.
      let ret = JSON.parse(JSON.stringify(state.productPeekabooFullWidth))
      return manipulateStructuredData(
        ret,
        getters.postersMetaData['peekaboo'],
        getters.posterColor,
        getters.posterPresentation,
        getters.currency,
        getters.getCurrLanguage
      )
    },

    structuredDataProductBabyroo (state, getters) {
      // Obtain the base return object.
      // JSON parse because: Error: [vuex] Do not mutate vuex store state outside mutation handlers.
      let ret = JSON.parse(JSON.stringify(state.productBabyrooFullWidth))
      return manipulateStructuredData(
        ret,
        getters.postersMetaData['babyroo'],
        getters.posterColor,
        getters.posterPresentation,
        getters.currency,
        getters.getCurrLanguage
      )
    },

    structuredDataProductFoxyStrollin (state, getters) {
      // Obtain the base return object.
      // JSON parse because: Error: [vuex] Do not mutate vuex store state outside mutation handlers.
      let ret = JSON.parse(JSON.stringify(state.productFoxyStrollinFullWidth))
      return manipulateStructuredData(
        ret,
        getters.postersMetaData['foxy-strollin'],
        getters.posterColor,
        getters.posterPresentation,
        getters.currency,
        getters.getCurrLanguage
      )
    },

    structuredDataProductMockingbird (state, getters) {
      // Obtain the base return object.
      // JSON parse because: Error: [vuex] Do not mutate vuex store state outside mutation handlers.
      let ret = JSON.parse(JSON.stringify(state.productMockingbirdFullWidth))
      return manipulateStructuredData(
        ret,
        getters.postersMetaData['mockingbird'],
        getters.posterColor,
        getters.posterPresentation,
        getters.currency,
        getters.getCurrLanguage
      )
    },

    structuredDataProductOwlinForYou (state, getters) {
      // Obtain the base return object.
      // JSON parse because: Error: [vuex] Do not mutate vuex store state outside mutation handlers.
      let ret = JSON.parse(JSON.stringify(state.productOwlinForYouFullWidth))
      return manipulateStructuredData(
        ret,
        getters.postersMetaData['owlin-for-you'],
        getters.posterColor,
        getters.posterPresentation,
        getters.currency,
        getters.getCurrLanguage
      )
    },

    structuredDataProductRetroBaby (state, getters) {
      // Obtain the base return object.
      // JSON parse because: Error: [vuex] Do not mutate vuex store state outside mutation handlers.
      let ret = JSON.parse(JSON.stringify(state.productRetroBabyFullWidth))
      return manipulateStructuredData(
        ret,
        getters.postersMetaData['retro-baby'],
        getters.posterColor,
        getters.posterPresentation,
        getters.currency,
        getters.getCurrLanguage
      )
    },

    structuredDataProductScandinavianForest (state, getters) {
      // Obtain the base return object.
      // JSON parse because: Error: [vuex] Do not mutate vuex store state outside mutation handlers.
      let ret = JSON.parse(JSON.stringify(state.productScandinavianForestFullWidth))
      return manipulateStructuredData(
        ret,
        getters.postersMetaData['scandinavian-forest'],
        getters.posterColor,
        getters.posterPresentation,
        getters.currency,
        getters.getCurrLanguage
      )
    },

    structuredDataProductBornStrong (state, getters) {
      // Obtain the base return object.
      // JSON parse because: Error: [vuex] Do not mutate vuex store state outside mutation handlers.
      let ret = JSON.parse(JSON.stringify(state.productBornStrongFullWidth))
      return manipulateStructuredData(
        ret,
        getters.postersMetaData['born-strong'],
        getters.posterColor,
        getters.posterPresentation,
        getters.currency,
        getters.getCurrLanguage
      )
    },

    structuredDataProductWhatTheFoxSay (state, getters) {
      // Obtain the base return object.
      // JSON parse because: Error: [vuex] Do not mutate vuex store state outside mutation handlers.
      let ret = JSON.parse(JSON.stringify(state.productWhatTheFoxSayFullWidth))
      return manipulateStructuredData(
        ret,
        getters.postersMetaData['what-the-fox-say'],
        getters.posterColor,
        getters.posterPresentation,
        getters.currency,
        getters.getCurrLanguage
      )
    },

    structuredDataProductShortyAndStretch (state, getters) {
      // Obtain the base return object.
      // JSON parse because: Error: [vuex] Do not mutate vuex store state outside mutation handlers.
      let ret = JSON.parse(JSON.stringify(state.productShortyAndStretchFullWidth))
      return manipulateStructuredData(
        ret,
        getters.postersMetaData['shorty-and-stretch'],
        getters.posterColor,
        getters.posterPresentation,
        getters.currency,
        getters.getCurrLanguage
      )
    },

    structuredDataProductAdorable (state, getters) {
      // Obtain the base return object.
      // JSON parse because: Error: [vuex] Do not mutate vuex store state outside mutation handlers.
      let ret = JSON.parse(JSON.stringify(state.productAdorableFullWidth))
      return manipulateStructuredData(
        ret,
        getters.postersMetaData['adorable'],
        getters.posterColor,
        getters.posterPresentation,
        getters.currency,
        getters.getCurrLanguage
      )
    },

    structuredDataProductPlayful (state, getters) {
      // Obtain the base return object.
      // JSON parse because: Error: [vuex] Do not mutate vuex store state outside mutation handlers.
      let ret = JSON.parse(JSON.stringify(state.productPlayfulFullWidth))
      return manipulateStructuredData(
        ret,
        getters.postersMetaData['playful'],
        getters.posterColor,
        getters.posterPresentation,
        getters.currency,
        getters.getCurrLanguage
      )
    },

    structuredDataProductDelightful (state, getters) {
      // Obtain the base return object.
      // JSON parse because: Error: [vuex] Do not mutate vuex store state outside mutation handlers.
      let ret = JSON.parse(JSON.stringify(state.productDelightfulFullWidth))
      return manipulateStructuredData(
        ret,
        getters.postersMetaData['delightful'],
        getters.posterColor,
        getters.posterPresentation,
        getters.currency,
        getters.getCurrLanguage
      )
    },

    structuredDataProductRosette (state, getters) {
      // Obtain the base return object.
      // JSON parse because: Error: [vuex] Do not mutate vuex store state outside mutation handlers.
      let ret = JSON.parse(JSON.stringify(state.productRosetteFullWidth))
      return manipulateStructuredData(
        ret,
        getters.postersMetaData['rosette'],
        getters.posterColor,
        getters.posterPresentation,
        getters.currency,
        getters.getCurrLanguage
      )
    },

    structuredDataProductBlossomA (state, getters) {
      // Obtain the base return object.
      // JSON parse because: Error: [vuex] Do not mutate vuex store state outside mutation handlers.
      let ret = JSON.parse(JSON.stringify(state.productBlossomAFullWidth))
      return manipulateStructuredData(
        ret,
        getters.postersMetaData['blossom-a'],
        getters.posterColor,
        getters.posterPresentation,
        getters.currency,
        getters.getCurrLanguage
      )
    },

    structuredDataProductBlossomB (state, getters) {
      // Obtain the base return object.
      // JSON parse because: Error: [vuex] Do not mutate vuex store state outside mutation handlers.
      let ret = JSON.parse(JSON.stringify(state.productBlossomBFullWidth))
      return manipulateStructuredData(
        ret,
        getters.postersMetaData['blossom-b'],
        getters.posterColor,
        getters.posterPresentation,
        getters.currency,
        getters.getCurrLanguage
      )
    },

    structuredDataProductBlossomC (state, getters) {
      // Obtain the base return object.
      // JSON parse because: Error: [vuex] Do not mutate vuex store state outside mutation handlers.
      let ret = JSON.parse(JSON.stringify(state.productBlossomCFullWidth))
      return manipulateStructuredData(
        ret,
        getters.postersMetaData['blossom-c'],
        getters.posterColor,
        getters.posterPresentation,
        getters.currency,
        getters.getCurrLanguage
      )
    },

    structuredDataProductBlossomD (state, getters) {
      // Obtain the base return object.
      // JSON parse because: Error: [vuex] Do not mutate vuex store state outside mutation handlers.
      let ret = JSON.parse(JSON.stringify(state.productBlossomDFullWidth))
      return manipulateStructuredData(
        ret,
        getters.postersMetaData['blossom-d'],
        getters.posterColor,
        getters.posterPresentation,
        getters.currency,
        getters.getCurrLanguage
      )
    },

    structuredDataProductBlossomE (state, getters) {
      // Obtain the base return object.
      // JSON parse because: Error: [vuex] Do not mutate vuex store state outside mutation handlers.
      let ret = JSON.parse(JSON.stringify(state.productBlossomEFullWidth))
      return manipulateStructuredData(
        ret,
        getters.postersMetaData['blossom-e'],
        getters.posterColor,
        getters.posterPresentation,
        getters.currency,
        getters.getCurrLanguage
      )
    },

    structuredDataProductBlossomF (state, getters) {
      // Obtain the base return object.
      // JSON parse because: Error: [vuex] Do not mutate vuex store state outside mutation handlers.
      let ret = JSON.parse(JSON.stringify(state.productBlossomFFullWidth))
      return manipulateStructuredData(
        ret,
        getters.postersMetaData['blossom-f'],
        getters.posterColor,
        getters.posterPresentation,
        getters.currency,
        getters.getCurrLanguage
      )
    },

    structuredDataProductBlossomG (state, getters) {
      // Obtain the base return object.
      // JSON parse because: Error: [vuex] Do not mutate vuex store state outside mutation handlers.
      let ret = JSON.parse(JSON.stringify(state.productBlossomGFullWidth))
      return manipulateStructuredData(
        ret,
        getters.postersMetaData['blossom-g'],
        getters.posterColor,
        getters.posterPresentation,
        getters.currency,
        getters.getCurrLanguage
      )
    },

    structuredDataProductBlossomH (state, getters) {
      // Obtain the base return object.
      // JSON parse because: Error: [vuex] Do not mutate vuex store state outside mutation handlers.
      let ret = JSON.parse(JSON.stringify(state.productBlossomHFullWidth))
      return manipulateStructuredData(
        ret,
        getters.postersMetaData['blossom-h'],
        getters.posterColor,
        getters.posterPresentation,
        getters.currency,
        getters.getCurrLanguage
      )
    },

    structuredDataProductBlossomI (state, getters) {
      // Obtain the base return object.
      // JSON parse because: Error: [vuex] Do not mutate vuex store state outside mutation handlers.
      let ret = JSON.parse(JSON.stringify(state.productBlossomIFullWidth))
      return manipulateStructuredData(
        ret,
        getters.postersMetaData['blossom-i'],
        getters.posterColor,
        getters.posterPresentation,
        getters.currency,
        getters.getCurrLanguage
      )
    },

    structuredDataProductBlossomJ (state, getters) {
      // Obtain the base return object.
      // JSON parse because: Error: [vuex] Do not mutate vuex store state outside mutation handlers.
      let ret = JSON.parse(JSON.stringify(state.productBlossomJFullWidth))
      return manipulateStructuredData(
        ret,
        getters.postersMetaData['blossom-j'],
        getters.posterColor,
        getters.posterPresentation,
        getters.currency,
        getters.getCurrLanguage
      )
    },

    structuredDataProductBlossomK (state, getters) {
      // Obtain the base return object.
      // JSON parse because: Error: [vuex] Do not mutate vuex store state outside mutation handlers.
      let ret = JSON.parse(JSON.stringify(state.productBlossomKFullWidth))
      return manipulateStructuredData(
        ret,
        getters.postersMetaData['blossom-k'],
        getters.posterColor,
        getters.posterPresentation,
        getters.currency,
        getters.getCurrLanguage
      )
    },

    structuredDataProductBlossomL (state, getters) {
      // Obtain the base return object.
      // JSON parse because: Error: [vuex] Do not mutate vuex store state outside mutation handlers.
      let ret = JSON.parse(JSON.stringify(state.productBlossomLFullWidth))
      return manipulateStructuredData(
        ret,
        getters.postersMetaData['blossom-l'],
        getters.posterColor,
        getters.posterPresentation,
        getters.currency,
        getters.getCurrLanguage
      )
    },

    structuredDataProductBlossomM (state, getters) {
      // Obtain the base return object.
      // JSON parse because: Error: [vuex] Do not mutate vuex store state outside mutation handlers.
      let ret = JSON.parse(JSON.stringify(state.productBlossomMFullWidth))
      return manipulateStructuredData(
        ret,
        getters.postersMetaData['blossom-m'],
        getters.posterColor,
        getters.posterPresentation,
        getters.currency,
        getters.getCurrLanguage
      )
    },

    structuredDataProductBlossomN (state, getters) {
      // Obtain the base return object.
      // JSON parse because: Error: [vuex] Do not mutate vuex store state outside mutation handlers.
      let ret = JSON.parse(JSON.stringify(state.productBlossomNFullWidth))
      return manipulateStructuredData(
        ret,
        getters.postersMetaData['blossom-n'],
        getters.posterColor,
        getters.posterPresentation,
        getters.currency,
        getters.getCurrLanguage
      )
    },

    structuredDataProductBlossomO (state, getters) {
      // Obtain the base return object.
      // JSON parse because: Error: [vuex] Do not mutate vuex store state outside mutation handlers.
      let ret = JSON.parse(JSON.stringify(state.productBlossomOFullWidth))
      return manipulateStructuredData(
        ret,
        getters.postersMetaData['blossom-o'],
        getters.posterColor,
        getters.posterPresentation,
        getters.currency,
        getters.getCurrLanguage
      )
    },

    structuredDataProductBlossomP (state, getters) {
      // Obtain the base return object.
      // JSON parse because: Error: [vuex] Do not mutate vuex store state outside mutation handlers.
      let ret = JSON.parse(JSON.stringify(state.productBlossomPFullWidth))
      return manipulateStructuredData(
        ret,
        getters.postersMetaData['blossom-p'],
        getters.posterColor,
        getters.posterPresentation,
        getters.currency,
        getters.getCurrLanguage
      )
    },

    structuredDataProductBlossomQ (state, getters) {
      // Obtain the base return object.
      // JSON parse because: Error: [vuex] Do not mutate vuex store state outside mutation handlers.
      let ret = JSON.parse(JSON.stringify(state.productBlossomQFullWidth))
      return manipulateStructuredData(
        ret,
        getters.postersMetaData['blossom-q'],
        getters.posterColor,
        getters.posterPresentation,
        getters.currency,
        getters.getCurrLanguage
      )
    },

    structuredDataProductBlossomR (state, getters) {
      // Obtain the base return object.
      // JSON parse because: Error: [vuex] Do not mutate vuex store state outside mutation handlers.
      let ret = JSON.parse(JSON.stringify(state.productBlossomRFullWidth))
      return manipulateStructuredData(
        ret,
        getters.postersMetaData['blossom-r'],
        getters.posterColor,
        getters.posterPresentation,
        getters.currency,
        getters.getCurrLanguage
      )
    },

    structuredDataProductBlossomS (state, getters) {
      // Obtain the base return object.
      // JSON parse because: Error: [vuex] Do not mutate vuex store state outside mutation handlers.
      let ret = JSON.parse(JSON.stringify(state.productBlossomSFullWidth))
      return manipulateStructuredData(
        ret,
        getters.postersMetaData['blossom-s'],
        getters.posterColor,
        getters.posterPresentation,
        getters.currency,
        getters.getCurrLanguage
      )
    },

    structuredDataProductBlossomT (state, getters) {
      // Obtain the base return object.
      // JSON parse because: Error: [vuex] Do not mutate vuex store state outside mutation handlers.
      let ret = JSON.parse(JSON.stringify(state.productBlossomTFullWidth))
      return manipulateStructuredData(
        ret,
        getters.postersMetaData['blossom-t'],
        getters.posterColor,
        getters.posterPresentation,
        getters.currency,
        getters.getCurrLanguage
      )
    },

    structuredDataProductBlossomU (state, getters) {
      // Obtain the base return object.
      // JSON parse because: Error: [vuex] Do not mutate vuex store state outside mutation handlers.
      let ret = JSON.parse(JSON.stringify(state.productBlossomUFullWidth))
      return manipulateStructuredData(
        ret,
        getters.postersMetaData['blossom-u'],
        getters.posterColor,
        getters.posterPresentation,
        getters.currency,
        getters.getCurrLanguage
      )
    },

    structuredDataProductBlossomV (state, getters) {
      // Obtain the base return object.
      // JSON parse because: Error: [vuex] Do not mutate vuex store state outside mutation handlers.
      let ret = JSON.parse(JSON.stringify(state.productBlossomVFullWidth))
      return manipulateStructuredData(
        ret,
        getters.postersMetaData['blossom-v'],
        getters.posterColor,
        getters.posterPresentation,
        getters.currency,
        getters.getCurrLanguage
      )
    },

    structuredDataProductBlossomW (state, getters) {
      // Obtain the base return object.
      // JSON parse because: Error: [vuex] Do not mutate vuex store state outside mutation handlers.
      let ret = JSON.parse(JSON.stringify(state.productBlossomWFullWidth))
      return manipulateStructuredData(
        ret,
        getters.postersMetaData['blossom-w'],
        getters.posterColor,
        getters.posterPresentation,
        getters.currency,
        getters.getCurrLanguage
      )
    },

    structuredDataProductBlossomX (state, getters) {
      // Obtain the base return object.
      // JSON parse because: Error: [vuex] Do not mutate vuex store state outside mutation handlers.
      let ret = JSON.parse(JSON.stringify(state.productBlossomXFullWidth))
      return manipulateStructuredData(
        ret,
        getters.postersMetaData['blossom-x'],
        getters.posterColor,
        getters.posterPresentation,
        getters.currency,
        getters.getCurrLanguage
      )
    },

    structuredDataProductBlossomY (state, getters) {
      // Obtain the base return object.
      // JSON parse because: Error: [vuex] Do not mutate vuex store state outside mutation handlers.
      let ret = JSON.parse(JSON.stringify(state.productBlossomYFullWidth))
      return manipulateStructuredData(
        ret,
        getters.postersMetaData['blossom-y'],
        getters.posterColor,
        getters.posterPresentation,
        getters.currency,
        getters.getCurrLanguage
      )
    },

    structuredDataProductBlossomZ (state, getters) {
      // Obtain the base return object.
      // JSON parse because: Error: [vuex] Do not mutate vuex store state outside mutation handlers.
      let ret = JSON.parse(JSON.stringify(state.productBlossomZFullWidth))
      return manipulateStructuredData(
        ret,
        getters.postersMetaData['blossom-z'],
        getters.posterColor,
        getters.posterPresentation,
        getters.currency,
        getters.getCurrLanguage
      )
    },

    structuredDataProductBlossomAring (state, getters) {
      // Obtain the base return object.
      // JSON parse because: Error: [vuex] Do not mutate vuex store state outside mutation handlers.
      let ret = JSON.parse(JSON.stringify(state.productBlossomAringFullWidth))
      return manipulateStructuredData(
        ret,
        getters.postersMetaData['blossom-aring'],
        getters.posterColor,
        getters.posterPresentation,
        getters.currency,
        getters.getCurrLanguage
      )
    },

    structuredDataProductBlossomAuml (state, getters) {
      // Obtain the base return object.
      // JSON parse because: Error: [vuex] Do not mutate vuex store state outside mutation handlers.
      let ret = JSON.parse(JSON.stringify(state.productBlossomAumlFullWidth))
      return manipulateStructuredData(
        ret,
        getters.postersMetaData['blossom-auml'],
        getters.posterColor,
        getters.posterPresentation,
        getters.currency,
        getters.getCurrLanguage
      )
    },

    structuredDataProductBlossomOuml (state, getters) {
      // Obtain the base return object.
      // JSON parse because: Error: [vuex] Do not mutate vuex store state outside mutation handlers.
      let ret = JSON.parse(JSON.stringify(state.productBlossomOumlFullWidth))
      return manipulateStructuredData(
        ret,
        getters.postersMetaData['blossom-ouml'],
        getters.posterColor,
        getters.posterPresentation,
        getters.currency,
        getters.getCurrLanguage
      )
    },

    structuredDataProductBlossomAelig (state, getters) {
      // Obtain the base return object.
      // JSON parse because: Error: [vuex] Do not mutate vuex store state outside mutation handlers.
      let ret = JSON.parse(JSON.stringify(state.productBlossomAeligFullWidth))
      return manipulateStructuredData(
        ret,
        getters.postersMetaData['blossom-aelig'],
        getters.posterColor,
        getters.posterPresentation,
        getters.currency,
        getters.getCurrLanguage
      )
    },

    structuredDataProductBlossomOslash (state, getters) {
      // Obtain the base return object.
      // JSON parse because: Error: [vuex] Do not mutate vuex store state outside mutation handlers.
      let ret = JSON.parse(JSON.stringify(state.productBlossomOslashFullWidth))
      return manipulateStructuredData(
        ret,
        getters.postersMetaData['blossom-oslash'],
        getters.posterColor,
        getters.posterPresentation,
        getters.currency,
        getters.getCurrLanguage
      )
    },

    structuredDataProductBlossomYuml (state, getters) {
      // Obtain the base return object.
      // JSON parse because: Error: [vuex] Do not mutate vuex store state outside mutation handlers.
      let ret = JSON.parse(JSON.stringify(state.productBlossomYumlFullWidth))
      return manipulateStructuredData(
        ret,
        getters.postersMetaData['blossom-yuml'],
        getters.posterColor,
        getters.posterPresentation,
        getters.currency,
        getters.getCurrLanguage
      )
    }

  }
}



// WEBPACK FOOTER //
// ./src/stores/structured-data.js